<template>
  <div id="checkbox-topic">
    <!-- <div>{{listData}}</div> -->
    <div
      :style="is_true"
      class="topic_title"
    >{{examinationItemData.order}}.( {{typeText}} ){{examinationItemData.questionTitle}}</div>
    <div class="topic_box">
      <el-checkbox-group disabled v-model="answer">
        <p :key="index" class="option" v-for="(item, index) in showData.questionSelect">
          <el-checkbox :label="item.value">{{item.lable}}</el-checkbox>
        </p>
      </el-checkbox-group>
    </div>
    <div class="el-Parsing">
      <div class="title">
        <div class="title_item">
          参考答案：
          <span class="blue">{{examinationItemData.questionAnswer | check_text}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{examinationItemData.select | check}}</span>
        </div>
        <div class="title_cursor">
          <el-popover placement="bottom-start" trigger="click" v-model="visible" width="400">
            <div class="text_box">
              <div class="header">
                <el-checkbox-group size="small" v-model="check_li">
                  <el-checkbox-button :key="item" :label="item" v-for="item in lists">{{item}}</el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div class="body">
                <el-input :rows="2" placeholder="请输入内容" type="textarea" v-model="textarea"></el-input>
              </div>
              <div class="submit">
                <div @click="submit_feed" class="btn">提交</div>
              </div>
            </div>
            <div :style="{'disabled': disabled}" class="warnin" slot="reference">
              <img alt src="@/assets/img/Exam/报错.png" srcset />
              <span>试题报错</span>
            </div>
          </el-popover>
          <div class="keep" v-if="!examinationItemData.isCollect">
            <img @click="collects" alt src="@/assets/img/Exam/收藏.png" srcset />
            <span class="no_keep">试题收藏</span>
          </div>
          <div class="keep" v-else>
            <img @click="collects" alt src="@/assets/img/Exam/已收藏.png" srcset />
            <span class="is_keep">已收藏</span>
          </div>
        </div>
      </div>
      <div
        class="content"
        v-if="examinationItemData.questionDescribe"
      >答案解析：{{examinationItemData.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
      <div class="btn_keep"></div>
    </div>
  </div>
</template>
<script>
import * as QUESTION_API from '@/api/ExaminationAPI'
export default {
  name: 'checkboxTopic',
  props: ['examinationItemData', 'typeText', 'topTypeId', 'courseId'],
  data () {
    return {
      answer: [],
      disabled: false,
      visible: false,
      lists: [
        '题干',
        '选项',
        '答案',
        '解析'
      ],
      textarea: '',
      check_li: ['题干'],
      showData: ''
    }
  },
  computed: {
    is_true () {
      let data = ''
      if (this.examinationItemData.isCorrect) {
        data = {
          'color': '#36ABFF'
        }
      }
      return data
    }
  },
  filters: {
    check (val) {
      if (val.indexOf('[') > -1) {
        return ''
      } else if (val.indexOf('###') > -1) {
        return val.replace(/###/g, '、')
      } else {
        return val
      }
    },
    check_text (val) {
      if (val.indexOf('###') > -1) {
        return val.replace(/###/g, '、')
      } else {
        return val
      }
    }
  },
  mounted () {
    let arr = this.examinationItemData.questionSelect
    if (!(arr instanceof Array)) {
      arr = arr.split('###')
      let obj = []
      for (let i = 0; i < arr.length; i++) {
        obj[i] = {}
        obj[i].lable = arr[i]
        obj[i].value = arr[i].substring(0, 1)
      }
      this.examinationItemData.questionSelect = obj
    }
    this.showData = this.examinationItemData
  },
  methods: {


    submit_feed () {
      let typeStr = "";
      if (this.check_li && this.check_li.length > 0) {
        for (let i = 0; i < this.check_li.length; i++) {
          if (i > 0) {
            typeStr += ","
          }
          const type = this.check_li[i];
          typeStr += type
        }
      }
      let data = {
        examinationItemId: this.examinationItemData.examinationItemId,
        content: typeStr + this.textarea,
        courseId: this.courseId,
        examinationId: this.examinationItemData.examinationId,
      }
      QUESTION_API.wrongFeedback(data).then(res => {
        if (res.data.code == 0) {
          this.$message.success(res.data.msg)
          this.visible = false
          this.disabled = true
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    editCollect (isDelete) {
      let myAnswer = this.examinationItemData.select.indexOf('[') > -1 ? '' : this.examinationItemData.select
      let data = {
        examinationItemId: this.examinationItemData.examinationItemId,
        examinationId: this.examinationItemData.examinationId,
        questionType: this.examinationItemData.questionType,
        myAnswer: myAnswer,
        topTypeId: this.topTypeId,
        courseId: this.courseId,
        isDelete: isDelete
      }
      QUESTION_API.editExaminationItemCollect(data).then(res => {
        // console.log(res, 'res')
        // if (res.code === 0) {

        // } else {

        // }
        this.$message.success(res.msg)
        let isCollect = true;
        if (isDelete == 1) {
          isCollect = false;
        }
        let obj = {
          examinationItemId: this.examinationItemData.examinationItemId,
          collect: isCollect,
          push: true
        }
        this.$emit('setCollect', obj)
      }).catch(err => {
        this.$message.warning(err)
        console.log(err)
      })
    },
    collects () {
      if (this.examinationItemData.isCollect) {
        this.editCollect(1)
      } else {
        this.editCollect(0)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.btn {
  cursor: pointer;
}
.eye_btn {
  margin: 10px;
}
.option {
  line-height: 40px;
}
.warnin img,
.warnin span {
  vertical-align: middle;
}
.warnin {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep img {
  vertical-align: middle;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.title_cursor {
  display: flex;
}
.title_item {
  margin-right: 75px;
}
.headtit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.el-Parsing {
  border-top: 1px solid rgba(242, 242, 242, 1);
  border-bottom: 1px solid rgba(242, 242, 242, 1);
  margin: 35px 0;
}
.content {
  margin-bottom: 20px;
}
.topic_title {
  line-height: 60px;
}
.boxcheck {
  display: inline-block;
  text-align: center;
  width: 25px;
  height: 25px;
  background: rgba(254, 254, 254, 1);
  border: 1px solid rgba(136, 136, 136, 1);
  border-radius: 50%;
  line-height: 22px;
}
.tive {
  background: rgba(255, 39, 64, 1);
  color: white;
  border: 1px solid rgba(255, 39, 64, 1);
}
.tives {
  background: rgba(71, 162, 255, 1);
  color: #ffffffff;
  border: 1px solid rgba(71, 162, 255, 1);
}
</style>